import script from "./AdminRequestMaterialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRequestMaterialDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdminRequestMaterialDialog.vue?vue&type=style&index=0&id=4e08b9c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e08b9c0"]])

export default __exports__